import {
    CheckCircle2,
    Upload,
    Eye
} from "lucide-react";

import Card from "../shared/Card";
import Button from "../shared/Button";

import {
    DOCUMENT_TYPES
} from "../../constants/documentTypes";
export default function DocumentsCard({

    documents = [],

    onUpload,

    onPreview

}) {

    function getDocument(type) {

        return documents.find(

            document =>

                document.doc_type === type.value

        );

    }

    return (

        <Card className="crm-documents-card">

            <div className="crm-card-header">

                <div>

                    <div className="crm-card-title">

                        Loan Documents

                    </div>

                    <div className="crm-doc-progress">

                        {

                            documents.length

                        }

                        /

                        {

                            DOCUMENT_TYPES.length

                        }

                        {" "}Uploaded

                    </div>

                </div>

            </div>

            {

                DOCUMENT_TYPES.map(type => {

                    const document =

                        getDocument(type);

                    return (

                        <div

                            key={type.value}

                            className="crm-document-row"

                        >

                            <div className="crm-document-left">

                                <div className="crm-document-title">

                                    {type.label}

                                </div>

                                {

                                    document

                                    ?

                                    <div className="crm-doc-ok">

                                        <CheckCircle2 size={15}/>

                                        Uploaded

                                    </div>

                                    :

                                    <div className="crm-doc-missing">

                                        Missing

                                    </div>

                                }

                            </div>

                            <div className="crm-document-actions">

                                {

                                    document &&

                                    <Button

                                        variant="ghost"

                                        icon={

                                            <Eye size={16}/>

                                        }

                                        onClick={()=>

                                            onPreview?.(

                                                document

                                            )

                                        }

                                    >

                                        View

                                    </Button>

                                }

                                <Button

                                    icon={

                                        <Upload size={16}/>

                                    }

                                    onClick={()=>

                                        onUpload?.(

                                            type.value

                                        )

                                    }

                                >

                                    {

                                        document

                                        ?

                                        "Replace"

                                        :

                                        "Upload"

                                    }

                                </Button>

                            </div>

                        </div>

                    );

                })

            }

<style>{`

.crm-documents-card{

    display:flex;

    flex-direction:column;

    gap:8px;

}

.crm-card-header{

    display:flex;

    justify-content:space-between;

    align-items:flex-start;

    margin-bottom:8px;

}

.crm-doc-progress{

    margin-top:4px;

    font-size:13px;

    color:#64748B;

}

.crm-document-row{

    display:flex;

    justify-content:space-between;

    align-items:center;

    padding:16px 0;

    border-bottom:1px solid #EEF2F7;

}

.crm-document-row:last-child{

    border-bottom:none;

}

.crm-document-left{

    display:flex;

    flex-direction:column;

    gap:6px;

}

.crm-document-title{

    font-weight:600;

    color:#0F172A;

}

.crm-document-actions{

    display:flex;

    align-items:center;

    gap:10px;

}

.crm-doc-ok{

    display:flex;

    align-items:center;

    gap:6px;

    color:#16A34A;

    font-size:13px;

    font-weight:500;

}

.crm-doc-missing{

    color:#DC2626;

    font-size:13px;

    font-weight:500;

}

`}</style>

        </Card>

    );

}